let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6W9rZ")).then(() => parcelRequire('k8Rr5'));